import { lazy } from "react";
import { carSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "gestionVehicles" */ './components/EntryPoint'));
const GestionLoader = lazy(() => import(/* webpackChunkName: "gestionVehiclesLoader" */ './components/GestionVehiclesLoader'));
const GestionDetail = lazy(() => import(/* webpackChunkName: "gestionVehiclesDetail" */ './components/GestionDetail/GestionDetails/GestionDetails.container'));

export const defaultPath = '/gestionVehicles';

export const innerRoutes = [
    {
        path: `${defaultPath}/detail/:id`,
        Component: GestionDetail,
        exact: true,
        icon: carSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: '',
            plural: false
        }
    },
    {
        path: `${defaultPath}/`,
        Component: GestionLoader,
        exact: true,
        icon: carSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: '',
            plural: false
        }
    }
];

const GestionVehicles = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: carSVG,
    title: {
        key: 'Gestión de vehículos',
        plural: false
    },
    subTitle: {
        key: 'Visualiza y gestiona los vehículos',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default GestionVehicles;
